<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <b-container>
    <div class="gare-container">
      <div v-if="step == 1">
        <div class="row">
          <div class="col-md-8">
            <GareGame :key="gareKey" ref="game" v-on:success="next" />
          </div>
          <div class="col-md-4">
            <div class="cadre">
              <p>
                Si tu ne peux pas écouter,
                <a
                  target="_blank"
                  href="https://cdn.exploreve.fr/content/IM2/IM2 L'aiguilleur (fichier pour les personnes malentendantes).pdf"
                >
                  clique ici
                </a>
              </p>

              <p>
                <audio controls>
                  <source src="https://cdn.exploreve.fr/content/IM2/audio/aiguilleur.mp3" type="audio/mpeg" />
                </audio>
              </p>

              <div class="arrow-bot"></div>
            </div>
            <div
              style="font-family: 'faune'; font-size: 12px; width: 180px; position: relative; top: 180px; left: 60px;"
            >
              <p>
                Ces rails sont complètement désorganisés ! Aide l’aiguilleur à les remettre dans l’ordre pour que le
                train puisse circuler jusqu'au cadre bleu. Certains rails peuvent pivoter, ce sont ceux qui sont
                entourés de rouge. Clique sur eux pour pivoter le rail jusqu’à la position qui te conviens. Attention,
                toutes les positions ne sont pas toujours possible… Quand tu as terminé, appuie sur play pour t’assurer
                que ton trajet fonctionne !
              </p>
            </div>
            <div style="position: absolute; bottom: 50px; right: -100px;">
              <img src="https://cdn.exploreve.fr/content/cluedo/Aiguilleur.svg" height="300px" />
            </div>
            <div class="boutons">
              <div class="bouton_gare" v-on:click="rerender">
                <img src="https://cdn.exploreve.fr/content/cluedo/BoutonReplay.svg" height="50px" />
              </div>
              <div class="bouton_gare" @click="$refs.game.anim('rt')">
                <img src="https://cdn.exploreve.fr/content/cluedo/BoutonPlay.svg" height="50px" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-md-8">
            <div style="text-align: center;">
              <img src="https://cdn.exploreve.fr/content/cluedo/caisse a outils.svg" height="300px" />
            </div>
            <div class="object" v-on:click="closeModal()">Récupérer la boîte à outils</div>
          </div>
          <div class="col-md-4">
            <div class="right" style="top: 10px;">
              <p>
                J’ai cru comprendre que tu avais un soucis de ballon. Pour te remercier de ton aide, voilà une boîte à
                outils pour t’aider à la réparer.
              </p>

              <div class="arrow-bot zef"></div>
            </div>
            <div style="position: absolute; top: 140px; right: 10px;">
              <img src="https://cdn.exploreve.fr/content/cluedo/Aiguilleur.svg" height="300px" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>
<style>
.arrow-bot {
  position: relative;
  content: "";
  top: -12px;
  left: 150px;
  width: 0px;
  height: 0px;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 15px solid white;
}

.zef {
  top: 80px !important;
  left: -200px !important;
}

.bouton_gare {
  margin: 10px;
}

.boutons {
  position: absolute;
  margin-top: auto;
  margin-bottom: auto;
  top: 200px;
  left: -10px;
  cursor: pointer;
}

.gare-container {
  width: 800px;
  height: 500px;
  position: relative;
  margin: auto;
}
.cadre {
  top: 10px;
  left: 10px;
  position: absolute;
  background-color: white;
  width: 350px;
  height: 100px;
  border-radius: 5px;
  text-align: left;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
}
</style>
<script>
import GareGame from "@/components/cluedo/Aiguillage.vue";
export default {
  data: function () {
    return {
      gareKey: 1,
      step: 1
    };
  },
  mounted() {},
  props: {},
  methods: {
    rerender() {
      this.gareKey += 1;
    },

    next() {
      this.step += 1;
      this.$emit("recupObject", "boiteAoutils");
    },
    closeModal() {
      this.$emit("closeModal");
    }
  },
  components: { GareGame }
};
</script>
